var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPointer(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.532 9.31185L6.58301 14.6112C6.41069 14.7261 6.17786 14.6795 6.06298 14.5072C6.02192 14.4456 6 14.3732 6 14.2992V3.70056C6 3.49346 6.16789 3.32556 6.375 3.32556C6.44903 3.32556 6.52142 3.34748 6.58301 3.38855L14.532 8.68785C14.7043 8.80275 14.7509 9.03555 14.636 9.2079C14.6085 9.24908 14.5732 9.2844 14.532 9.31185Z",
    fill: "#3B3E3F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPointer);
export default __webpack_public_path__ + "static/media/pointer.7b5d7006d42a4800d39d0277a2e23930.svg";
export { ForwardRef as ReactComponent };